import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const attributes = Object.freeze({
  color: "",
  classes: "",
  size: "24",
});

export default function Tick({
  attributes = {
    color: "",
    classes: "",
    size: "",
  },
  clickHandler = () => {},
}) {
  const navigate = useNavigate();
  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        fill={attributes.color}
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5.676,8.237-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,1,1,1.414-1.414l2.323,2.323,5.294-4.853a1,1,0,1,1,1.352,1.474Z" />
      </svg>
    </div>
  );
}
